/** Shared service-window X geometry for Curve + Breakdown Gantt. */
export const RIBBON_PLOT_W = 1000;
/** Left inset — sized for Gantt table Y-labels; Curve shares the same X. */
export const RIBBON_PAD_L = 48;
export const RIBBON_PAD_R = 8;

export function ribbonPlotWidth(
  padL = RIBBON_PAD_L,
  padR = RIBBON_PAD_R,
  w = RIBBON_PLOT_W,
): number {
  return w - padL - padR;
}

/** Fraction of the service window [openH, closeH] for a service-hour value. */
export function ribbonTimeFrac(
  hour: number,
  openH: number,
  closeH: number,
): number {
  const span = Math.max(1e-6, closeH - openH);
  return Math.max(0, Math.min(1, (hour - openH) / span));
}

export function ribbonXAtHour(
  hour: number,
  openH: number,
  closeH: number,
  padL = RIBBON_PAD_L,
  padR = RIBBON_PAD_R,
  w = RIBBON_PLOT_W,
): number {
  return padL + ribbonTimeFrac(hour, openH, closeH) * ribbonPlotWidth(padL, padR, w);
}

/** CSS left % for an HTML overlay aligned to the SVG viewBox X. */
export function ribbonXPct(
  hour: number,
  openH: number,
  closeH: number,
  padL = RIBBON_PAD_L,
  padR = RIBBON_PAD_R,
  w = RIBBON_PLOT_W,
): number {
  return (ribbonXAtHour(hour, openH, closeH, padL, padR, w) / w) * 100;
}
